export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('select');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;


    var model = MODEL.extend({
        defaults: {
            ...MODEL.prototype.defaults,
            name: "select",
            "custom-name": "select",
            attributes: {
            },
            classes: [],
            traits: MODEL.prototype.defaults.traits.concat([
                {
                    type: 'checkbox',
                    name: 'data-lg-follow-in-query',
                    label: 'Follow in query'
                }
            ])
        },
        

    }, {
        isComponent(el) {
            
            if (el.tagName === 'SELECT') {
                return { type: 'select' };
            }
        },
    });
    var view = VIEW.extend({
        // onRender({el, model}) {
        //     console.log(el);
        //     // console.log(model.get('components'));
        //     let  options = model.get('components');
        //     for (let i = 0; i < options.length; i++) {
        //         const option = options.models[i];
        //         console.log(option);
        //         console.log(option.get('content'));
        //     }
        // }
    });

    DOMC.addType('select', {
        model: model,
        view: view
    });

    const traitManager = editor.TraitManager;
    traitManager.addType('select-options', {
        events:{
            'keyup': 'onChange',
        },

        onValueChange: function () {
            const optionsStr = this.model.get('value').trim();
            const options = optionsStr.split('\n');
            const optComps = [];

            for (let i = 0; i < options.length; i++) {
                const optionStr = options[i];
                const option = optionStr.split(opts.optionsStringSeparator);
                const opt = {
                    tagName: 'option',
                    attributes: {}
                };
                if(option[1]) {
                    opt.content = option[1];
                    opt.attributes.value = option[0];
                } else {
                    opt.content = option[0];
                    opt.attributes.value = option[0];
                }
                optComps.push(opt);
            }

            const comps = this.target.get('components');
            comps.reset(optComps);
            this.target.view.render();

        },

        getInputEl: function() {
            if (!this.$input) {
                console.log(this);
                const target = this.target;
                let optionsStr = '';
                const targetViewEl = target.view.el;

                const options = Array.from(targetViewEl.querySelectorAll("option"));
                // const options = target.get('components');

                for (let i = 0; i < options.length; i++) {
                    const option = options[i];
                    const optValue = option.value || '';
                    console.log(option)
                    const optContent = option.textContent || '';
                    optionsStr += `${optValue}${opts.optionsStringSeparator}${optContent}\n`;
                    console.log(optionsStr);
                }

                this.$input = document.createElement('textarea');
                this.$input.value = optionsStr;
            }
            return this.$input;
        },
    });


    

}
